import React, { useMemo } from 'react';
import { Input } from '@heroui/react';

interface INumberRangeProps {
	label?: string;
	fromValue: number | null | undefined;
	toValue: number | null | undefined;
	onFromChange: (value: string) => void;
	onToChange: (value: string) => void;
	minValue?: number;
	maxValue?: number;
	fromPlaceholder?: string;
	toPlaceholder?: string;
	isDisabled?: boolean;
	size?: 'sm' | 'md' | 'lg';
	className?: string;
	step?: number | 'any';
}

export const NumberRange: React.FC<INumberRangeProps> = ({
	label,
	fromValue,
	toValue,
	onFromChange,
	onToChange,
	minValue,
	maxValue,
	fromPlaceholder,
	toPlaceholder,
	isDisabled = false,
	size = 'sm',
	className = '',
	step = 'any',
}) => {
	// Validation: check if from value is greater than to value
	const hasValidationError = useMemo(() => {
		if (fromValue !== null && fromValue !== undefined && 
			toValue !== null && toValue !== undefined) {
			return fromValue > toValue;
		}
		return false;
	}, [fromValue, toValue]);

	const errorMessage = hasValidationError ? 'From value cannot be greater than To value' : '';
	return (
		<div className={`flex w-full items-center ${className}`}>
			{label && <span className="text-sm w-1/4">{label}:</span>}
			<div className="flex items-center justify-between w-full">
				<Input
					type="number"
					value={fromValue?.toString() ?? ''}
					onChange={(e) => onFromChange(e.target.value)}
					size={size}
					isDisabled={isDisabled}
					placeholder={fromPlaceholder}
					min={minValue}
					max={maxValue}
					step={step}
					className="rounded-none"
					isInvalid={hasValidationError}
					errorMessage={hasValidationError ? errorMessage : undefined}
				/>
				<span className="text-sm mx-2">to</span>
				<Input
					type="number"
					value={toValue?.toString() ?? ''}
					onChange={(e) => onToChange(e.target.value)}
					size={size}
					isDisabled={isDisabled}
					placeholder={toPlaceholder}
					min={minValue}
					max={maxValue}
					step={step}
					className="rounded-none"
					isInvalid={hasValidationError}
					errorMessage={hasValidationError ? errorMessage : undefined}
				/>
			</div>
		</div>
	);
};
